import * as React from 'react'
import { compose, pure } from 'recompose'

import { Plan } from '../../../../../commons/Plan'
import Button from '../../../atoms/Button/Button'
import LimitTextField from '../../../molecules/LimitTextField/LimitTextField'
import EditorQuizURLModal from '../../EditorQuizURLModal/EditorQuizURLModal'
import * as styles from './MobileEditorHeader.css'

interface MobileEditorHeaderProps {
  onChangeProjectTitleText: (data: any) => void
  projectTitle: string
  isModalShow: boolean
  showModal: () => void
  hideModal: () => void
  shareParam: string
  plan: Plan
  eventTitle: string
  handleChangeProjectStarted: (input: boolean) => void
  isStarted: boolean
  expireDate: string
  handleClickOpenPresentationWindow: () => void
  handleDownloadRankingData: () => void
  isFetchableRankingData: boolean
}

const MobileEditorHeader: React.FunctionComponent<MobileEditorHeaderProps> = ({
  projectTitle,
  onChangeProjectTitleText,
  isModalShow,
  showModal,
  hideModal,
  shareParam,
  plan,
  handleChangeProjectStarted,
  isStarted,
  expireDate,
  handleClickOpenPresentationWindow,
  handleDownloadRankingData,
  isFetchableRankingData
}) => {
  return (
    <React.Fragment>
      <header className={styles.container}>
        <div className={styles.textField}>
          <LimitTextField
            idx={0}
            limitLength={20}
            text={projectTitle}
            handleChange={onChangeProjectTitleText}
            showLimitCount={false}
          />
        </div>
        <div className={styles.button}>
          <Button isRadius={false} handleClick={showModal}>
            <p className={styles.buttonText}>再生</p>
          </Button>
        </div>
      </header>
      <EditorQuizURLModal
        shareParam={shareParam}
        plan={plan}
        isModalShow={isModalShow}
        hideModal={hideModal}
        handleChangeAccept={handleChangeProjectStarted}
        isStarted={isStarted}
        expireDate={expireDate}
        handleClickOpenPresentationWindow={handleClickOpenPresentationWindow}
        handleDownloadRankingData={handleDownloadRankingData}
        isFetchableRankingData={isFetchableRankingData}
      />
    </React.Fragment>
  )
}

export default compose(pure)(MobileEditorHeader)
